module.exports = __webpack_public_path__ + "img/ico-eye-open.56996493.svg";